import ScrollReveal from "@/components/base/ScrollReveal";
import childTherapyImage from "../../../media/child theraphy hero image.png";

const groups = [
  {
    label: "Children",
    age: "Ages 6–12",
    headline: "Support that helps children feel understood",
    body: "Warm, age-appropriate therapy helps children express big feelings, build coping skills, and navigate school, friendships, and family changes.",
    img: childTherapyImage,
    accent: "#C58B65",
    ctaColor: "#8B6248",
    href: "/child-therapy",
  },
  {
    label: "Teens",
    age: "Ages 13–17",
    headline: "Support for teens when things feel overwhelming",
    body: "School pressure, identity, social dynamics, and family stress can feel overwhelming. We work with teens to help make sense of what's going on and build tools that actually help.",
    img: "/images/homepage/teen-card-image.png",
    imgPosition: "40% 30%",
    accent: "#B4A6E3",
    ctaColor: "#7D54FC",
    href: "/teen-therapy",
  },
  {
    label: "Adults",
    age: "All stages of adulthood",
    headline: "Navigate what life is actually asking of you",
    body: "Anxiety, burnout, relationships, career transitions, grief. Therapy helps you get clear on what's driving your patterns and how to change them.",
    img: "/images/homepage/adult-card-image.png",
    accent: "#3C6FF8",
    ctaColor: "#3C6FF8",
    href: "/individual-therapy",
  },
  {
    label: "Couples",
    age: "Partners at any stage",
    headline: "Work through it together with real support",
    body: "Whether you're navigating conflict, disconnection, or a major transition, couples therapy helps you build better communication and deeper understanding.",
    img: "/images/homepage/Couples-card-image.png",
    accent: "#6B742F",
    ctaColor: "#6B742F",
    href: "/couples-therapy",
  },
];

export default function WhoWeHelp() {
  return (
    <section id="who-we-help" className="w-full py-14 md:py-20" style={{ background: "linear-gradient(180deg, #F8F5EE 0%, #F5F1E8 40%, #F2EEE4 100%)" }}>
      <div className="w-full px-6 md:px-12 lg:px-20">
        {/* Header */}
        <div className="max-w-xl mb-10 md:mb-12">
          <ScrollReveal variant="fadeIn" delay={0}>
            <span className="font-manrope text-[13px] font-semibold tracking-widest uppercase text-[#7D54FC]/90 block mb-4">
              Who We Work With
            </span>
          </ScrollReveal>
          <ScrollReveal variant="fadeUp" delay={80}>
            <h2 className="font-fraunces text-[#2B2B2B] text-4xl md:text-5xl font-light leading-snug">
              Therapy that meets you<br />
              <em className="not-italic" style={{ color: "#7D54FC" }}>right where you are</em>
            </h2>
          </ScrollReveal>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 lg:gap-8">
          {groups.map((g, i) => (
            <ScrollReveal key={g.label} variant="fadeUp" delay={i * 110}>
              <a
                href={g.href}
                className="group rounded-2xl overflow-hidden border transition-all h-full card-hover"
                aria-label={`Learn about therapy for ${g.label.toLowerCase()}`}
                style={{ background: "rgba(255,255,255,0.55)", borderColor: "rgba(203,191,175,0.3)" }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = g.accent + "55";
                  e.currentTarget.style.background = "rgba(255,255,255,0.85)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "rgba(203,191,175,0.3)";
                  e.currentTarget.style.background = "rgba(255,255,255,0.55)";
                }}
              >
                <div className="w-full h-64 md:h-72 overflow-hidden relative">
                  <img
                    src={g.img}
                    alt={`Therapy for ${g.label}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    style={{ objectPosition: g.imgPosition || "center top" }}
                  />
                  <div
                    className="absolute top-4 left-4 px-3 py-1 rounded-full font-manrope text-xs font-semibold"
                    style={{ backgroundColor: g.accent, color: "#fff" }}
                  >
                    {g.label}
                  </div>
                </div>
                <div className="p-6 md:p-7">
                  <div className="flex items-center gap-2.5 mb-4">
                    <span className="inline-block h-1.5 w-5 rounded-full" style={{ backgroundColor: g.accent }}></span>
                    <span className="font-manrope text-[12px] font-semibold tracking-widest uppercase text-[#2B2B2B]/70">
                      {g.age}
                    </span>
                  </div>
                  <h3 className="font-fraunces text-[#2B2B2B] text-xl font-medium mb-3 leading-snug">
                    {g.headline}
                  </h3>
                  <p className="font-manrope text-[#2B2B2B]/78 text-[15px] leading-relaxed">
                    {g.body}
                  </p>
                  <span className="mt-5 inline-flex items-center gap-2 font-manrope text-sm font-semibold" style={{ color: g.ctaColor }}>
                    Learn more <span aria-hidden="true">→</span>
                  </span>
                </div>
              </a>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
